import {Box, styled} from '@mui/material';

export const StyledSubHeader = styled(Box)`
	padding: 1px 16px 16px;
	background-color: ${({theme}) => theme.palette.primary.main};
	margin-top: -1px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 1px 32px 24px;
	}
`;

export const StyledBox = styled(Box)`
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: 60px;
	}
`;
